import React from 'react';
import { Slider } from '@mui/material';

const SlideMain = ({ className, ...props }) => {
  return <Slider {...props} className={className ? className : 'slider-main'} />;
};
export default SlideMain;
